import Footer from '@react/shared/components/Footer';
import Header from '@react/shared/components/Header/Header.container';
import Helmet from 'next/head';
import { StrictMode, useEffect } from 'react';
import { Showcase, SlyPartnerBanner } from 'sly/b2b';
import { referralSolutions, TYPEFORM_LINK } from 'sly/b2b/constants';
import { pageNames, useEvents } from 'sly/services/events';

import ProviderClaimProfile from './ProviderClaimProfile';
import ProviderIndexHeader from './providerIndexHeader';

export default function CommunitiesIndex() {
  const { events } = useEvents();

  useEffect(() => {
    events.page(pageNames.PartnerCommunities, {});
  }, []);

  return (
    <StrictMode>
      <Helmet>
        <title>Senior Living Companies and Providers | Seniorly</title>
        <meta
          name='description'
          content='Take a look at some of the largest senior living companies in the country. Seniorly can help you find out more about different senior living providers.'
        />
      </Helmet>
      <header className='relative'>
        <Header />
      </header>
      <ProviderIndexHeader />
      <Showcase
        // title={referralSolutions.title}
        // description={referralSolutions.description}
        items={referralSolutions.solutions}
      />
      <ProviderClaimProfile />
      {/* <Showcase
        title={conversionSolutions.title}
        description={conversionSolutions.description}
        items={conversionSolutions.solutions}
      /> */}
      <SlyPartnerBanner page='B2B provider page' link={TYPEFORM_LINK} />
      <Footer />
    </StrictMode>
  );
}

CommunitiesIndex.whyDidYouRender = true;
